import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "./axiosInstance";

export const fetchToken = createAsyncThunk(
    'askCreator/fetchToken',
    async ({ email_id }) => {      
        try {
            const response = await axiosNoAuth.post('https://ninjacurate.learntube.ai/user_authenticate', { user_email: email_id });
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
);

export const getUserRole = createAsyncThunk(
    'getUserRole',
    async ({ email }) => {
        try {
            const response = await axiosNoAuth.get(`https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user/check_core_platform_role?email=${email}`)
            return response.data
        } catch (error) {
            console.log(error.message)
            throw error;
        }
    }
)

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState: {
        email: '',
        userName: '',
        userPhone: '',
        userRole: {
            user_role: 0,
            role_type: ''
        }
    },
    reducers: {
        logoutUser(state) {
            state.token = null;
            // Other state cleanup related to logout
        },
        setUserEmail(state, action) {
            state.email = action.payload;
        },
        setAuthenticationError(state, action) {
            state.error = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchToken.fulfilled, (state, action) => {
            if (action.payload.access_token){
                return {
                    ...state,
                    uid: action?.payload?.uid,
                    token: action?.payload?.access_token,
                    userName: action?.payload?.user_name,
                    userPhone: action?.payload?.user_phone
                }
           } else {
                return {
                    ...state,
                    error: action?.payload?.Error
                }
           }
        })
        .addCase(getUserRole.fulfilled, (state, action) => {
            state.userRole = action.payload
        })
    },
});

export const { logoutUser, setUserEmail, setAuthenticationError } = authenticationSlice.actions
export const selectAuthentication = (state) => state.personaliseLessons?.authentication;
export default authenticationSlice.reducer;